import script from "./players.vue?vue&type=script&setup=true&lang=js"
export * from "./players.vue?vue&type=script&setup=true&lang=js"

import "./players.vue?vue&type=style&index=0&id=5faa1ed4&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5faa1ed4"]])

export default __exports__